<template>
	<v-layout column align-center class="content-pad-vert">
		<v-flex xs12 md8 offset-md-2>
			<h4>Change password</h4>
			<v-text-field
				v-model="newPassword"
				label="New Password"
				min="8"
				:rules="[rules.required, rules.min_length, rules.include_lower, rules.include_upper, rules.include_number, rules.include_special]"
				:append-icon="e1 ? 'visibility' : 'visibility_off'"
				:append-icon-cb="() => (e1 = !e1)"
				:type="e1 ? 'password' : 'text'"
				counter
			></v-text-field>
			<v-text-field
				v-model="confirmPassword"
				label="Confirm Password"
				min="8"
				:append-icon="e2 ? 'visibility' : 'visibility_off'"
				:append-icon-cb="() => (e2 = !e2)"
				:type="e2 ? 'password' : 'text'"
				counter
			></v-text-field>
			<div
				style="color: red;"
				v-for="(e, index) in error"
				:key="index"
			>
				{{ e }}
			</div>
			<div style="color: green;">
				{{ success }}
			</div>
			<v-btn @click="update">
				Update Password
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
import axios from 'axios'

export default {
	data() {
		return {
			e1: true,
			e2: true,
			newPassword: '',
			confirmPassword: '',
			error: [],
			success: '',
			rules: {
				required: value => !!value || 'Required.',
				min_length: value =>
					value.length > 7 || 'Minimum length is 8 characters',
				include_lower: value => {
					return /.*[a-z].*/.test(value) || 'Must include a lowercase letter'
				},
				include_upper: value => {
					return /.*[A-Z].*/.test(value) || 'Must include an uppercase letter'
				},
				include_number: value => {
					return /.*[0-9].*/.test(value) || 'Must include a number'
				},
				include_special: value => {
					return (
						/.*[!@#$%^*?&~=+|\\\/\(\)\{\[\]}\-_\<\>\.].*/.test(value) ||
						'Must include a special character'
					)
				}
			}
		}
	},
	methods: {
		update() {
			if (this.newPassword === this.confirmPassword) {
				axios
					.post('/rest-auth/password/reset/confirm/', {
						uid: this.$route.params.uid,
						token: this.$route.params.token,
						new_password1: this.newPassword,
						new_password2: this.confirmPassword
					})
					.then(response => {
						this.error = []
						this.success = response.data
					})
					.catch(error => {
						console.error(error)
						this.error = []
						for (let i in error.response.data) {
							this.error.push(error.response.data[i])
						}
					})
			} else {
				this.error = ['Password and confirmation do not match']
			}
		}
	}
}
</script>
